<template>
    <div class="sidebar-detail">
        <div class="detail-header-container">
            <h4 class="page-title">{{ detailInfo.name }}</h4>
            <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times" /></div>
        </div>

        <p class="detail-title">{{ 'Details' }}</p>
        <div>
            <table class="recording-detail-table">
                <tr>
                    <td>{{ $t('detail.Id') }}</td>
                    <td>{{ (detailInfo.id) || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.Workflow') }}</td>
                    <td>{{ ((detailInfo.workflow||{}).name) || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.NumberOfTasks') }}</td>
                    <td>{{ (detailInfo.numberOfTasks) || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.SubjectType') }}</td>
                    <td>{{ ((detailInfo.subjectType||{}).name) || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.FormCategory') }}</td>
                    <td>{{ ((detailInfo.formCategory||{}).name) || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.Sequence') }}</td>
                    <td>{{ detailInfo.sequence || '-' }}</td>
                </tr>
            </table>
        </div>

        <p class="detail-title">{{ $t('detail.ShareForm') }}</p>
        <table class="recording-detail-table">
            <tr>
                <td>{{ $t('detail.IsPublic') }}</td>
                <td align="right">
                    <!-- <sharing-toggle 
                        share-item="FORM"
                        :form="detailInfo"
                        :is-public.sync="detailInfo.isPublic" 
                        :public-form-link="publicFormLink"
                        @handleIsPublicChange="handleIsPublicChange"
                        @updatePublicFormInfo="updatePublicFormInfo"
                    /> -->
                </td>
            </tr>
            <tr v-if="detailInfo.isPublic">
                <td class="vertical-align">
                    <p>{{ $t('detail.PublicLink') }}</p>
                </td>
                <td class="vertical-align">
                    <!-- <copy-link :qrImgName="qrImgName" :message="publicFormLink"></copy-link> -->
                </td>
            </tr>
            <!-- <tr>
                <td><p>{{$t('detail.PublicLinkQRCode')}}</p></td>
                <td align="right">
                    <el-tooltip class="item" effect="dark" content="QR Code" placement="top">
                        <el-button
                            class="copy-btn"
                            size="mini"
                            v-clipboard:copy="message"
                            v-clipboard:success="onCopy"
                        ><i class="fas fa-qrcode"></i></el-button>
                    </el-tooltip>
                </td>
            </tr> -->
        </table>

        <p class="detail-title">{{ $t('detail.DateTime') }}</p>
        <div class="user-datetime-container">
            <table>
                <tr>
                    <td>{{ $t('detail.Modified') }}</td>
                    <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('detail.Created') }}</td>
                    <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                </tr>
            </table>
        </div>

        <div v-if="detailInfo" class="button-group-container">
            <detail-btn param-name="formId" :param-id="detailInfo.id" page-name="FormRecording" />
            <div class="button-group-edit-delete">
                <edit-btn v-if="isEditPermission" param-name="formId" :param-id="detailInfo.id" page-name="EditForm" class="sidebar-edit-btn" />
                <delete-btn v-if="isEditPermission" class="sidebar-delete-btn" @confirmDelete="handleDelete" />
            </div>
        </div>
    </div>
</template>

<script>
import DeleteButton from "@/components/Button/DeleteButton";
import DetailButton from "@/components/Button/DetailButton";
import EditButton from "@/components/Button/EditButton";
import { formDelete, formUpdatePublic } from "@/api/form";
// import SharingToggle from "./SharingToggle";
// import copyLink from './copyLink'
// import QRCodeLink from "@/components/QRCodeLink";

export default {
    components: {
        "delete-btn": DeleteButton,
        "detail-btn": DetailButton,
        "edit-btn": EditButton,
        // "sharing-toggle": SharingToggle,
        // 'copy-link': copyLink,
        // "qr-code-link": QRCodeLink,
    },
    props: {
        detailInfo: {
            type: Object
        }
    },
    data() {
        return {
            publicCode: null
        };
    },
    computed: {
        publicFormLink() {
            let code = this.publicCode ? this.publicCode : this.detailInfo.publicCode;
            return `${window.location.protocol}//${window.location.host}/darwin-sharing-form/${code}`;
        },
        qrImgName() {
            if (this.detailInfo) return `form_${this.detailInfo.name}_${this.detailInfo.id}`;
            else return "";
        },
        isEditPermission() {
            return this.$_isIncludePermission("Permissions.Darwin.Forms.Edit");
        },
        isDeletePermission() {
            return this.$_isIncludePermission("Permissions.Darwin.Forms.Delete");
        }
    },
    methods: {
        async handleIsPublicChange(event) {
            let res = await formUpdatePublic(this.detailInfo);
            if (res) {
                this.publicCode = res.publicCode;
            }
        },
        async updatePublicFormInfo(event) {
            let res = await formUpdatePublic({
                "id": this.detailInfo.id,
                "isPublic": true,
                ...event
            });
            if (res) {
                this.publicCode = res.publicCode;
            }
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        },
        async handleDelete() {
            var res = await formDelete({ Id: this.detailInfo.id });
            if (res) {
                this.$_triggerSuccessNotify("Form Deleted");
                this.$store.dispatch("info_sidebar/getAllLatestData", "FORM");
            }
        }
    }
};
</script>

<style lang="css" scoped>
.sidebar-detail p{
    margin: var(--space-8) 0;
}
.sidebar-detail ul li{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
}
.recording-detail-table tr td{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
    padding: var(--space-4) var(--space-8);
    color: var(--charcoal-black)
}
.detail-title {
    font-weight: 700;
    line-height: 30px;
    border-bottom: 1px solid #eeeeee;
    color: var(--main-color-1)
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
}
.is-public-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.get-link-button {
    margin-left: var(--space-8);
}
.vertival-align > * {
    vertical-align : middle;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/FormSidebar.vue